import script from "./OtpByMail.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpByMail.vue?vue&type=script&setup=true&lang=js"

import "./OtpByMail.vue?vue&type=style&index=0&id=8e96cb48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e96cb48"]])

export default __exports__